
import ProductItemPresenter from "../../products-list/presenter/product-item.js";
import ProductQuantityPresenter from "../../product-quantity/presenter/product-quantity.js";

import CartProductItemView from "../view/cart-product-item.js";
import CartItemSummaryView from "../view/cart-item-summary.js";

import {
  render,
  RenderPosition,
  removeElement
} from "../../render/render.js";

import {
  defaultCartProductItemModelData,
  ActionType,
  REMOVE_ITEM_ANIMATION_DURATION,
  CONNECTOR_URL,
  RequestAction
} from "../const.js";

import {
  sendXhrQueue,
} from "../../../utils/send-xhr/send-xhr.js";
export default class CartProductItem extends ProductItemPresenter {
  constructor(element, id, animationComponent, listPresenter) {
    super(element, id, animationComponent);

    this._ItemView = CartProductItemView;
    this._listPresenter = listPresenter;

    this._itemModelData = Object.assign(
        {},
        this._itemModelData,
        defaultCartProductItemModelData
    );

    this._productQuantityPresenter = null;
    this._itemSummaryView = null;
    this._requestQueue = {};

    this._handleCartDataChange = this._handleCartDataChange.bind(this);
    this._handleRemoveButtonClick = this._handleRemoveButtonClick.bind(this);
  }

  init() {
    super.init();

    this._itemView.setRemoveButtonClickHandler(this._handleRemoveButtonClick);

    const isSummaryRendered = (this._itemView.getSummaryElement()) ?
      true :
      false;

    this._itemModel.changeData(Object.assign(
        {},
        this._itemModel.getData(),
        {
          sessionElementId: this._itemView.getsessionElementId(),
          price: this._itemView.getPrice(),
          quantity: this._itemView.getQuantity(),
          totalPrice: this._itemView.getTotalPrice(),
          isSummaryRendered
        }
    ), ActionType.INIT);

    this._productQuantityPresenter = new ProductQuantityPresenter(
        this._itemView.getQuantityElement(),
        this._itemModel.getData().sessionElementId
    );
    this._productQuantityPresenter.init();

    if (window.CartData) {
      window.CartData.addObserver(this._handleCartDataChange);
    }
  }

  adjustLayout() {
    const modelData = this._itemModel.getData();

    if (modelData.isLayoutChanged) {
      return;
    }

    this._itemModel.changeData(Object.assign(
        {},
        modelData,
        {
          isLayoutChanged: true
        }
    ), ActionType.ADJUST_LAYOUT);
  }

  resetCartItemView() {
    const modelData = this._itemModel.getData();

    if (!modelData.isLayoutChanged) {
      return;
    }

    this._itemModel.changeData(Object.assign(
        {},
        modelData,
        {
          isLayoutChanged: false
        }
    ), ActionType.RESET_VIEW);
  }

  _renderSummary() {
    const modelData = this._itemModel.getData();

    this._itemSummaryView = new CartItemSummaryView();
    this._itemSummaryView.setOptions({
      price: modelData.price,
      quantity: modelData.quantity
    });

    if (modelData.isLayoutChanged) {
      render(this._itemView.getPropertiesWrapperElement(), this._itemSummaryView.getElement());
    } else {
      render(this._itemView.getProductFormElement(), this._itemSummaryView.getElement(), RenderPosition.BEFOREBEGIN);
    }

    this._itemView.setTotalPriceValue(this._itemModel.getData().totalPrice);
    this._animation.fadeIn(this._itemSummaryView.getElement());
  }

  _hideSummary() {
    const itemSummaryElement = this._itemSummaryView.getElement();
    this._itemSummaryView = null;

    this._animation.fadeOut(
        itemSummaryElement,
        null,
        () => {
          removeElement(itemSummaryElement);
        }
    );
  }

  _removingItem() {
    this._itemView.setRemoving();

    const requestArgs = {
      body: [
        `action=${RequestAction.REMOVE_PRODUCT}`,
        `session_element_id=${this._itemModel.getData().sessionElementId}`
      ],
      connectorUrl: CONNECTOR_URL,
      loadCallback: (response) => {
        const data = JSON.parse(response);
        this._processRemoving(data);
      },
      errorCallback: () => {
        this._processRemoveError();
      },
      requestQueue: this._requestQueue
    };
    sendXhrQueue(requestArgs);
  }

  _processAdjustingLayout() {
    render(this._itemView.getPropertiesWrapperElement(), this._itemView.getTotalPriceElement());

    if (this._itemSummaryView) {
      render(this._itemView.getPropertiesWrapperElement(), this._itemSummaryView.getElement());
    }
  }

  _processResetingView() {
    render(this._itemView.getProductFormElement(), this._itemView.getTotalPriceElement(), RenderPosition.BEFOREBEGIN);

    if (this._itemSummaryView) {
      render(this._itemView.getProductFormElement(), this._itemSummaryView.getElement(), RenderPosition.BEFOREBEGIN);
    }
  }

  _removeItem(action, payload) {
    const itemElement = this._itemView.getElement();
    this._listPresenter.removeItem(this);

    if (window.CartData) {
      window.CartData.removeObserver(this._handleCartDataChange);
    }

    this._animation.slideUp(
        itemElement,
        REMOVE_ITEM_ANIMATION_DURATION,
        null,
        () => {
          removeElement(itemElement);
        }
    );

    if (window.CartData) {
      window.CartData.changeData(Object.assign(
          {},
          window.CartData.getData(),
          payload
      ), action, payload);
    }
  }

  _setRemoveError() {
    this._itemView.unsetRemoving();
  }

  _processRemoving(payload) {
    if (this._itemModel.getData().isRemoved) {
      return;
    }

    this._itemModel.changeData(Object.assign(
        {},
        this._itemModel.getData(),
        {
          isRemoved: true
        }
    ), ActionType.REMOVE, payload);
  }

  _processRemoveError() {
    if (!this._itemModel.getData().isRemoving) {
      return;
    }

    this._itemModel.changeData(Object.assign(
        {},
        this._itemModel.getData(),
        {
          isRemoving: false
        }
    ), ActionType.REMOVE_ERROR);
  }

  _handleRemoveButtonClick(evt) {
    evt.preventDefault();

    if (this._itemModel.getData().isRemoving) {
      return;
    }

    this._itemModel.changeData(Object.assign(
        {},
        this._itemModel.getData(),
        {
          isRemoving: true
        }
    ), ActionType.REMOVING);
  }

  handleChangeData(action, payload) {
    super.handleChangeData(action);

    switch (action) {
      case ActionType.ADJUST_LAYOUT:
        this._processAdjustingLayout();
        break;
      case ActionType.RESET_VIEW:
        this._processResetingView();
        break;
      case ActionType.INIT:
        if (this._itemModel.getData().isSummaryRendered) {
          this._itemSummaryView = new CartItemSummaryView();
          this._itemSummaryView.setElement(this._itemView.getSummaryElement());
        }
        break;
      case ActionType.SHOW_SUMMARY:
        this._renderSummary();
        break;
      case ActionType.HIDE_SUMMARY:
        this._hideSummary();
        this._itemView.setTotalPriceValue(this._itemModel.getData().totalPrice);
        break;
      case ActionType.REMOVING:
        this._removingItem();
        break;
      case ActionType.REMOVE:
        this._removeItem(action, payload);
        break;
      case ActionType.REMOVE_ERROR:
        this._setRemoveError();
        break;
      default:
        this._itemView.setTotalPriceValue(this._itemModel.getData().totalPrice);

        if (this._itemSummaryView) {
          this._itemSummaryView.setQuantity(this._itemModel.getData().quantity);
        }
        break;
    }
  }

  _handleCartDataChange(action, payload) {
    switch (action) {
      case ActionType.ADD_QUANTITY:
      case ActionType.REMOVE_QUANTITY:
      case ActionType.INVALID_CHECK:
      case ActionType.BLUR:
      case ActionType.SUBMIT:
      case ActionType.CHANGE:
        if (this._itemView && payload.sessionElementId === this._itemView.getsessionElementId()) {
          let isSummaryRendered;

          if (!this._itemSummaryView && payload.currentItemQuantity > 1) {
            action = ActionType.SHOW_SUMMARY;
            isSummaryRendered = true;
          }

          if (this._itemSummaryView && payload.currentItemQuantity === 1) {
            action = ActionType.HIDE_SUMMARY;
            isSummaryRendered = false;
          }

          this._itemModel.changeData(Object.assign(
              {},
              this._itemModel.getData(),
              {
                quantity: payload.currentItemQuantity,
                totalPrice: payload.currentItemQuantity * this._itemView.getPrice(),
                isSummaryRendered
              }
          ), action);
        }
        break;
    }
  }
}
